module.exports = __webpack_public_path__ + "media/images/home/logo1-3b28bb73b28c98898b0d3a84f9e5038a.png";